import {getInfo, login, loginBySms, logout} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {userCurrentInfo} from "@/api/sys/user";
// import store from '../index'

const user = {
  state: {
    // token
    token: getToken(),
    // 姓名
    name: '',
    // 用户ID
    userId: '',
    // 角色
    roles: [],
    // 权限
    permissions: [],
    deptName: '',
    userData: {},//用户所有信息
    currentInfoUserData: {},//当前登录用户信息
    // 当前登录所选部门（刷新后从 sessionStorage 恢复）
    currentDeptId: sessionStorage.getItem('currentDeptId') || '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_DEPTNANE: (state, deptName) => {
      state.deptName = deptName
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_USERDATA: (state, user) => {
      state.userData = user
    },
    //当前登录用户信息
    SET_CURRENT_INFO_USERDATA: (state, info) => {
      state.currentInfoUserData = info;
    },
    SET_CURRENT_DEPT_ID: (state, id) => {
      state.currentDeptId = id || ''
      if (id) {
        sessionStorage.setItem('currentDeptId', id)
      } else {
        sessionStorage.removeItem('currentDeptId')
      }
    },
  },

  actions: {
    // 登录
    LoginByAccount({commit}, userInfo) {
      const username = userInfo.account.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      const phone = userInfo.phone
      const deviceType='pc_web'
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid,phone,deviceType).then(res => {
          if (res && res.code === 200) {
            // 重新登录需重新拉用户信息并选部门
            commit('SET_ROLES', [])
            commit('SET_CURRENT_DEPT_ID', '')
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 短信登录
    LoginBySms({commit}, userInfo) {
      const phone = userInfo.phone.trim()
      const code = userInfo.code
      return new Promise((resolve, reject) => {
        loginBySms(phone, code).then(res => {
          if (res && res.code === 200) {
            commit('SET_ROLES', [])
            commit('SET_CURRENT_DEPT_ID', '')
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          const data = res.data
          if (data.roleKeys && data.roleKeys.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roleKeys)
            commit('SET_PERMISSIONS', data.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', data.useName)
          commit('SET_USERID', data.userId)
          commit('SET_USERDATA', data)//用户信息

          // 获取当前登录用户信息（等待完成后再 resolve，便于 jump 选部门）
          return userCurrentInfo().then(detailRes => {
            commit('SET_CURRENT_INFO_USERDATA', detailRes.data)//当前登录用户信息
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
     // 获取用户信息
     GetCurrentInfoUserData({commit, state}) {
      // 获取当前登录用户信息
      userCurrentInfo().then(res => {
        commit('SET_CURRENT_INFO_USERDATA', res.data)//当前登录用户信息
      })
     },

    // 退出系统
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_NAME', '')
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_CURRENT_DEPT_ID', '')
          // localStorage.clear()
          // if(store.state.user.userData.deptTypeCode == '10' && store.state.user.userData.userId != '-1'){ //领导角色退出登录
          //   localStorage.setItem('isFirstLogin',false)//是否第一次登录
          // }
          sessionStorage.clear()
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_CURRENT_DEPT_ID', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
